
const messages = {
   en: {
      base: {
         home: 'Home',
         about: 'About',
         welcome: "Welcome"
      }
   },
   es: {
      base: {
         home: 'Principal',
         about: 'Acerca de',
         welcome: "Bienvenido"
      }
   },
   pt: {
      base: {
         home: 'Principal',
         about: 'Acerca de',
         welcome: "Welcome"
      }
   }
}

export default messages
    